<template>
    <div class="app-container">
        <!-- 信息栏 -->
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>基本信息</span>
                <i :class="isOpen? 'el-icon-caret-top' :'el-icon-caret-bottom'" style="float:right; cursor: pointer;" @click="isOpen = !isOpen"></i>
            </div>
            <div class="info-box" v-if="isOpen">
                <div class="item">
                    <span>标识：</span>
                    <span>{{infoData.eventCode}}</span>
                </div>
                <div class="item">
                    <span>所属游戏：</span>
                    <span>{{infoData.appkey}}</span>
                </div>
                <div class="item">
                    <span>表名：</span>
                    <span>{{infoData.eventName}}</span>
                </div>
                <div class="item">
                    <span>显示名称：</span>
                    <span v-if="!infoData.editEvent">{{infoData.eventDesc}}</span>
                    <el-input v-model="infoData.eventDesc" size="mini" placeholder="请输入" style="width:120px" v-if="infoData.editEvent"></el-input>
                    <i class="el-icon-edit" style="color:#1890ff; cursor: pointer; margin-left: 5px" v-if="!infoData.editEvent" @click="handleEditMenu"></i>
                    <i class="el-icon-check" style="color:#06ff05; cursor: pointer; margin-left: 5px" v-if="infoData.editEvent" @click="handleSaveMenu"></i>
                    <i class="el-icon-close" style="color:#ff051a; cursor: pointer; margin-left: 5px" v-if="infoData.editEvent" @click="handleCancelMenu"></i>
                </div>
                <div class="item">
                    <span>是否显示：</span>
                    <el-switch v-model="infoData.isRead" size="mini" active-color="#13ce66" inactive-color="#ff4949" @change="handleSwitchInfo"></el-switch>
                </div>

                <div class="item">
                    <span>备注：</span>
                    <span v-if="!infoData.editRemark">{{infoData.desc}}</span>
                    <el-input v-if="infoData.editRemark" type="textarea" placeholder="请输入内容" v-model="infoData.desc" maxlength="30" show-word-limit style="width: 300px"></el-input>
                    <i class="el-icon-edit" style="color:#1890ff; cursor: pointer; margin-left: 5px" v-if="!infoData.editRemark" @click="handleEditRemark"></i>
                    <i class="el-icon-check" style="color:#06ff05; cursor: pointer; margin-left: 5px" v-if="infoData.editRemark" @click="handleSaveRemark"></i>
                    <i class="el-icon-close" style="color:#ff051a; cursor: pointer; margin-left: 5px" v-if="infoData.editRemark" @click="handleCancelRemark"></i>
                </div>
            </div>
        </el-card>

        <!-- 表格 -->
         <el-card class="box-card" style="margin-top:20px">
            <div slot="header" class="clearfix">
                <span>字段信息</span>
                
                <el-tooltip effect="dark" content="正在开发中" placement="top">
                   <el-button size="mini" class="filter-item" type="primary" style="margin: 0 10px">新增</el-button>
                </el-tooltip>
                <!-- <el-button size="mini" class="filter-item" type="primary" disabled style="float: right;">新增</el-button> -->

                <!-- 搜索 -->
                <el-input placeholder="请输入内容" size="small" v-model="search" clearable style="width:200px; margin-right: 15px" ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                
                <div style="display:inline-block">
                    <span>展示：</span>
                    <el-select size="small" v-model="isShow" placeholder="请选择" >
                        <el-option v-for="item in showOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>

                <div class="filterButn" style="float:right;">
                    <el-popover width="400" trigger="click">
                        <el-button slot="reference" size="mini" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
                        <el-checkbox-group class="checkbox-group" v-model="checkboxTitle">
                            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
                        </el-checkbox-group>
                    </el-popover>
                </div>
            </div>

            <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" size='mini' :key="key" border v-loading="listLoading" :data="tableList" style="width: 100%">
                <el-table-column v-for="(item,index) in tableTheads" align="center" :key="index" :label="item[Object.keys(item)[0]]" min-width="100px">
                    <template slot-scope="scope" >
                        <el-switch v-model="scope.row[Object.keys(item)[0]]" size="mini" active-color="#13ce66" inactive-color="#ff4949" @change="handleSwitch($event, scope.row)" v-if="Object.keys(item)[0] == 'isRead'"></el-switch>
                        <span v-else> {{ scope.row[Object.keys(item)[0]] }}</span>
                    </template>

                </el-table-column>

                <el-table-column label="操作" align="center" width="160px" class-name="small-padding fixed-width" fixed="right">
                    <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                    <el-button type="text" class="bdc-table-op-muted" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-tooltip effect="dark" content="正在开发中" placement="top" >
                        <el-button type="text" class="bdc-table-op-danger" disabled>删除</el-button>
                    </el-tooltip>
                    </div>
                    </template>
                </el-table-column>

            </el-table>
         </el-card>

         <!-- 添加 编辑 弹窗 -->
        <el-dialog :title="dialogType == 'add' ? '新增' : '编辑'+dialogTitle" v-if="dialogForm" :close-on-click-modal="false" :visible.sync="dialogForm"  append-to-body width="600px" top="10vh">
            <el-form :model="postForm" :rules="ruleForm" ref="postForm" label-width="100px" >
                <!-- <el-form-item label="所属游戏：" prop="appkey">
                    <el-input size="small" v-model="postForm.appkey" style="width: 300px" disabled></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="字段名" prop="trueField">
                    <el-input size="small" v-model="postForm.trueField" style="width: 300px"></el-input>
                </el-form-item> -->
                <el-form-item label="显示名称" prop="fieldDesc">
                    <el-input size="small" v-model="postForm.fieldDesc" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="翻译" >
                    <el-input size="small" v-model="postForm.translate" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="条件类型" prop="parameterType">
                   <el-select size="small" v-model="postForm.parameterType" placeholder="请选择" style="width: 300px">
                        <el-option v-for="item in parameterTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-input size="small" v-model="postForm.parameter" placeholder='输入字段名称' v-if="postForm.parameterType == '9999'" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="是否排序" prop="orderType">
                   <el-select size="small" v-model="postForm.orderType" placeholder="请选择" style="width: 300px">
                        <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="展示序列" prop="orderNum" v-if="postForm.orderType !== 0">
                    <el-input size="small" type="number" min="1" v-model="postForm.orderNum" style="width: 300px"></el-input>
                </el-form-item>

                 <el-form-item label="展示" prop="isRead">
                    <el-switch size="small" v-model="postForm.isRead" active-color="#13ce66" inactive-color="#ff4949" ></el-switch>
                </el-form-item>
            </el-form>

            <!-- 按钮组 -->
            <div class="butn-box" style="text-align: right; padding: 20px;">
                <el-button type="primary" @click="handleSave" >确认</el-button>
                <el-button @click="dialogForm=false">关闭</el-button>
            </div>

        </el-dialog>
        
    </div>
</template>

<script>
import {ajax_manageInfo, ajax_manageSwitch, ajax_manageUpdate, ajax_manageMenuUpdate} from '@Bdc~/api/ajax_model'

const defaultFormThead = [
    {id: '编号'},
    {mapField: '字段标识'},
    {trueField: '字段名称'},
    {colTypeDesc: '字段类型'},
    {fieldDesc: '显示名称'},
    {translate: '翻译'},
    {parameterTypeDesc: '条件'},
    {orderTypeDesc: '排序'},
    {isRead: '展示'}
]

export default {
    data() {
        return {
            infoData: {
                eventCode: '', // 标识
                appkey: '', // 所属游戏
                eventName: '', // 表名
                eventDesc: '', // 显示名称
                originalEventDesc:'',
                editEvent: false, // 修改显示名称
                isRead: true, // 是否显示
                desc: '', // 备注
                originalDesc:'',
                editDesc: false, // 修改备注

            },
            listLoading: false,
            tableData: [],
            key: 1, // table key
            tableTheadOptions:defaultFormThead,
            tableTheads:defaultFormThead,
            checkboxTitle:defaultFormThead,

            // 新增 编辑弹窗
            dialogType: 'add',
            dialogForm: false,
            dialogTitle: '',
            postForm: {},
            ruleForm: {
                trueField: { required: true, message: '请填写字段名', trigger: ['blur','change'] },
                fieldDesc: { required: true, message: '请填写显示名称', trigger: ['blur','change'] },
                orderNum: { required: true, message: '请填写值类型', trigger: ['blur','change'] },
                isRead: { required: true, message: '请选择是否展示', trigger: ['blur','change'] },
            },
            
            // 条件类型
            parameterTypeOptions:[
                {value: '1', label: '模糊查询'},
                {value: '2', label: '精确查询'},
                {value: '3', label: '区间值'},
                {value: '4', label: '时间段'},
                {value: '9999', label: '字段名称'},
            ],
            // 是否排序
            orderTypeOptions:[
                {value: 0, label: '不排'},
                {value: 1, label: '正序'},
                {value: 2, label: '倒序'}
            ],

            //基本信息是否展示
            isOpen: true,

            search: '', // 搜索 
            isShow: '0', // 展示不展示
            showOptions: [{value:'0',label:'全部'},{value:'1',label:'展示'},{value:'2',label:'不展示'},]
        }
    },
    watch: {
        // 筛选表名
        checkboxTitle(valArr) {
            // console.log(valArr)
            this.tableTheads = this.tableTheadOptions.filter(i => valArr.indexOf(i) >= 0)
            // console.log(this.tableTheads)
            this.key = this.key + 1
        }
    },

    computed: {
        // 模糊搜索 表格
        tableList() {
            const search = this.search
            const isShow = this.isShow
            if(search) {
                return this.tableData.filter(data => {
                    return Object.keys(data).some(key => {
                        if(isShow == 1) { // 展示
                            // console.log('展示====')
                            return String(data[key]).toLowerCase().indexOf(search) > -1 && data['isRead']
                        } else if(isShow == 2) { // 不展示
                            // console.log('不展示====')
                            return String(data[key]).toLowerCase().indexOf(search) > -1 && !data['isRead']
                        } else { // 全部
                            // console.log('全部====')
                            return String(data[key]).toLowerCase().indexOf(search) > -1
                        }
                       
                    })
                })
            } else {
                return this.tableData.filter(data => {
                    return Object.keys(data).some(key => {

                        if(isShow == 1) { // 展示
                            // console.log('展示====')
                            return data['isRead']
                        } else if(isShow == 2) { // 不展示
                            // console.log('不展示====')
                            return !data['isRead']
                        } else { // 全部
                            // console.log('全部====')
                            return data
                        }
                    })
                })
            }
            // console.log('表格：======',this.tableData)
            return this.tableData
        },
    },

    methods:{
        // 获取详情
        getList(eventCode) {
            ajax_manageInfo(eventCode).then(response => {
                if(response.code == 1) {
                    this.infoData = {
                        eventCode: response.data.eventCode, // 标识
                        appkey: response.data.appkey, // 所属游戏
                        eventName: response.data.eventName, // 表名
                        eventDesc: response.data.eventDesc, // 显示名称
                        originalEventDesc: response.data.eventDesc,
                        editEvent: false, // 修改显示名称
                        isRead:  response.data.isRead, // 是否显示
                        desc: response.data.desc, // 备注
                        originalDesc:response.data.desc,
                        editRemark: false, // 修改备注
                    } 
                     
                    this.tableData = response.data.columns
                } else {
                    this.$message.error( response.msg);
                }
            })
        },

        // 开关
        handleSwitch(val, item) {
            console.log(val, item)
            ajax_manageSwitch(item.id,'isRead', val).then(response =>{
                if(response.code == 1) {
                    // this.$message({
                    //     message: '',
                    //     type: 'success'
                    // });
                } else {
                    this.$message.error( response.msg);
                }
            })
        },

        // 编辑
        handleEdit(row) {
            this.dialogType = 'edit'
            this.dialogTitle = row.trueField // 字段名
            this.dialogForm = true
            this.postForm = JSON.parse(JSON.stringify(row))
            this.$set(this.postForm, 'parameter', row.parameterType)

            console.log(this.postForm.parameterType)

            if(!this.postForm.orderType) {
                this.postForm.orderType = 0
            }

            if(this.postForm.parameterType && this.postForm.parameterType != '1' && this.postForm.parameterType != '2' && this.postForm.parameterType != '3' && this.postForm.parameterType != '4' ) {
                
                this.postForm.parameterType = '9999'
            }

            this.$nextTick(() => {
                this.$refs['postForm'].clearValidate()
            })
        },

        // 提交 数据
        handleSave() {
            this.$refs['postForm'].validate((valid) => {
                if (valid) {

                    const data = {
                        id: this.postForm.id,
                        trueField: this.postForm.trueField,
                        fieldDesc: this.postForm.fieldDesc,
                        translate: this.postForm.translate,
                        parameterType: this.postForm.parameterType == '9999' ? this.postForm.parameter : this.postForm.parameterType,
                        orderType: this.postForm.orderType,
                        orderNum: this.postForm.orderNum,
                        isRead: this.postForm.isRead
                    }

                    console.log(data)

                    ajax_manageUpdate(data).then(response => {
                        if(response.code == 1) {
                            this.dialogForm = false
                            this.getList(this.infoData.eventCode)
                        } else {
                            this.$message.error( response.msg);
                        }
                    })
                }
            })
        },

        // 编辑 显示名称
        handleEditMenu() {
            this.infoData.editEvent = true
        },

        // 保存 显示名称
        handleSaveMenu() {
            if(!this.infoData.eventDesc){
               this.$message.error('表名不能为空');
               return
            }
            ajax_manageMenuUpdate(this.infoData.eventCode, 'eventDesc', this.infoData.eventDesc).then(response => {
                if(response.code == 1) {
                    this.infoData.editEvent = false
                    this.$message({
                        message: '修改表名成功',
                        type: 'success'
                    });

                    this.$emit('renewList')

                }
            })

        },

        // 取消 显示名称 修改
        handleCancelMenu(item) {
            this.infoData.eventDesc = this.infoData.originalEventDesc
            this.infoData.editEvent = false
           // console.log(this.infoData.eventDesc, this.infoData.editEvent)
        },

        // 编辑 备注
        handleEditRemark() {
            this.infoData.editRemark = true
            console.log('修改备注', this.infoData.editRemark)
        },

        // 保存 备注
        handleSaveRemark() {
            console.log('保存修改备注', this.infoData.editRemark)
            if(!this.infoData.desc){
               this.$message.error('表名不能为空');
               return
            }
            ajax_manageMenuUpdate(this.infoData.eventCode, 'desc', this.infoData.desc).then(response => {
                if(response.code == 1) {
                    this.infoData.editRemark = false
                    this.$message({
                        message: '修改表名成功',
                        type: 'success'
                    });
                }
            })

        },

        // 取消备注修改
        handleCancelRemark() {
             this.infoData.desc = this.infoData.originalDesc
            this.infoData.editRemark = false
            console.log('取消修改备注', this.infoData.editRemark)
        },

        // 是否显示
        handleSwitchInfo(val) {
            ajax_manageMenuUpdate(this.infoData.eventCode, 'isRead', this.infoData.isRead).then(response => {
                if(response.code == 1) {
                    // this.$message({
                    //     message: '修改表名成功',
                    //     type: 'success'
                    // });
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .app-container{
        padding: 10px;
    }
    .box-card{ 
        width: 100%;
        ::v-deep .el-card__header{
            padding: 10px 12px !important;
        }
        ::v-deep .el-card__body{
            padding: 10px !important;
        }
    }
    .info-box{
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        padding: 10px 10px 0;
        .item{
            min-width: 30%;
            margin-right: 15px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 18px;
        }
        .all{
            min-width: 100%;
        }
        .title{
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
        }

    }
    .checkbox-group{
        display: flex;
        flex-flow: row wrap;
        .el-checkbox{
            margin: 10px;
        }
    }
</style>